import { CHECKOUT_KLARNA_PAYMENT } from '../Components/Checkout/other/CheckoutConstants';

export const klarnaSuspend = () => {
  if (window._klarnaCheckout) {
    window._klarnaCheckout((api) => {
      api.suspend();
    });
  }
};

export const klarnaResume = () => {
  if (window._klarnaCheckout) {
    window._klarnaCheckout((api) => {
      api.resume();
    });
  }
};

export const isKlarnaPayment = (selectedPaymentMethod) =>
  selectedPaymentMethod?.id === CHECKOUT_KLARNA_PAYMENT;
